/*
 * @prop --component-link-color-icon: Fill color of only the icon
*/

:host {
  --item-spacing: var(--ui-link-list-spacing, 17px);

  display: block;

  ui-headline + .linklist,
  ui-headline + .multicolumn {
    margin-top: 12px;
  }

  .linklist {
    @include list-unstyled;

    box-sizing: border-box;
    margin: 0;

    > li {
      margin-bottom: var(--item-spacing);

      &:last-child {
        margin-bottom: 0;
      }

      &.icon {
        position: relative;

        ui-icon {
          height: 24px;
          width: 24px;
          margin-right: 8px;
          vertical-align: text-bottom;
          fill: var(
            --component-link-color-icon,
            var(
              --component-link-color-text,
              var(--current-color-primary, var(--ui-color-blue-600))
            )
          );
        }
      }
    }

    &--horizontal-buttons {
      font-size: 0;
      margin-top: 24px;

      > li {
        display: inline-block;
        font-size: 17px;
        margin-right: 16px;
        overflow: hidden; /* clearfix for following elements on floated lists */

        &:last-child {
          // overwrite existing 0px last child rule
          margin-bottom: var(--item-spacing);
        }
      }
    }

    &--anchor {
      li {
        font-weight: $font-weight-bold;
        margin-bottom: 20px;
        font-size: 18px;
      }
    }

    &--horizontal-tags {
      li {
        display: inline-block;
        margin: 0;
        padding: 0;
        // focus should be done on the parent tag of ui-pill to reach the desired effects
        &:focus {
          .ui-pill {
            outline: 2px groove
              var(
                --component-pill-outline-color,
                var(--current-color-primary, $ui-blue)
              );
            outline-offset: 2px;
          }
        }
      }
    }
  }

  .multicolumn {
    @include breakpoint($small) {
      @include clearfix();
      /* stylelint-disable function-no-unknown */
      margin-left: -1 * gutter();
      margin-right: -1 * gutter();
      /* stylelint-enable function-no-unknown */
    }

    &--2,
    &--3 {
      .linklist {
        @include breakpoint($small) {
          > li:last-child {
            margin-bottom: 0;
          }
        }

        > li:last-child {
          margin-bottom: var(--item-spacing);
        }

        &:last-child {
          > li:last-child {
            margin-bottom: 0;
          }
        }
      }
    }

    &--2 {
      .linklist {
        @include breakpoint($small) {
          @include span(6 of 12);
        }
      }
    }

    &--3 {
      .linklist {
        @include breakpoint($small) {
          @include span(4 of 12);
        }
      }
    }
  }

  @extend %subsup;
}
